import { COLORS } from "@app/constants";
import React, { useContext } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { data, getIntroOfPage } from "../../CryptoCurrencyTrend/chartData";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="intro">{getIntroOfPage(label)}</p>
        <p className="desc">Anything you want can be displayed here.</p>
      </div>
    );
  }
  return null;
};
const RenderLegend = (props: any) => {
  const { gray, textw } = useContext(ThemeContext).theme.COLORS;
  const { payload } = props;
  return (
    <ul
      style={{
        backgroundColor: gray,
        width: "80%",
        margin: "auto",
        borderRadius: 5,
      }}
    >
      {payload.map((entry: any, index: any) => (
        <li key={`item-${index}`} style={{ color: textw }}>
          {entry.value}
        </li>
      ))}
    </ul>
  );
};
const CryptoPriceGraph = () => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  return (
    <View style={{ width: "100%", height: "70%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart width={730} height={250} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fill: textw, fontSize: 13 }} />
          <YAxis tick={{ fill: textw, fontSize: 13 }} />
          <Tooltip
            cursor={{
              stroke: COLORS.lightGray4,
              strokeWidth: 2,
              strokeDasharray: 2,
            }}
            separator={" "}
            itemStyle={{}}
            wrapperStyle={{}}
            contentStyle={{}}
            labelStyle={{}}
            label={"Hello world"}
            content={<CustomTooltip />}
            // content is custom tooltip can delete to change default
          />
          <Legend verticalAlign="bottom" content={RenderLegend} />
          <Bar dataKey="pv" fill="#8884d8" />
          <Bar dataKey="uv" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </View>
  );
};

export default React.memo(CryptoPriceGraph);
